/* @flow */

export default class InsertBatchInvoiceRequest {
  sellerCompanyId: number;
  debtorCompanyId: number;
  entries: BatchInvoiceEntryRequest[];

  constructor() {
    this.entries = [];
  }
}

export class BatchInvoiceEntryRequest {
  reference: string;
  debtorReference: string;
  debtAmount: number;
  issueDate: string;
  dueDate: string;
}
